<template>
  <div class="content">
    <div class="img-content" :class="[isfinished == 1 ? success : fail]">
      <div class="txt">{{ subtitle }}</div>
      <div class="txt txt-title">{{ title }}</div>
    </div>
    <div class="cell-content" v-if="isShowFirstCell || isShowSecondCell">
      <div class="cell" @click="onTapFirstCell" v-if="isShowFirstCell">
        <div class="title">{{ firstCellTitle }}</div>
        <div class="subtitle">{{ firstCellSubtitle }}</div>
      </div>
      <div class="cell" @click="onTapSecondCell" v-if="isShowSecondCell">
        <div class="title">{{ secondCellTitle }}</div>
        <div class="subtitle">{{ secondCellSubtitle }}</div>
      </div>
    </div>
    <div class="btn-content" v-if="btnTxt">
      <div class="btn" @click="onTapBtn">{{ btnTxt }}</div>
    </div>
    <div class="txt-content" v-if="isShowSubNotice">
      <div class="txt-space"></div>
      <div class="txt-b">
        <p>通常我们会在问卷关闭后的7天内完成提现。</p>
        <p>通过加速提现，您可以在1个工作日完成提现。</p>
        <p>未来我们还将提供即时提现服务。</p>
      </div>
      <div class="txt-space"></div>
    </div>

    <div class="bulbs-card" v-if="isShowBulb">
      <div class="bulbs-inside">
        <Bulbs show="false" />
      </div>
    </div>

    <card
      v-if="isShow"
      type="2"
      :dialog="dialog"
      @closeDialog="closeDialog"
      @tixianAgain="onTapTixianAgain"
    />
  </div>
</template>

<script>
import { getCookie, removeCookie } from "../utils";
import Bulbs from "../components/Bulbs";
import Card from "../components/DialogCard";

export default {
  components: {
    Bulbs,
    Card
  },

  data() {
    return {
      dialog: {},
      isShow: false,
      isShowBulb: false,
      btnTxt: "",
      isfinished: 1,
      unionId: "",
      type: 1,
      prId: "",
      TID: "",
      nowLevel: "2",
      success: "success",
      fail: "fail",
      title: "",
      subtitle: "",
      isShowFirstCell: true,
      isShowSecondCell: true,
      firstCellTitle: "",
      firstCellSubtitle: "",
      secondCellTitle: "",
      secondCellSubtitle: "",
      isShowSubNotice: false,

      t: "",
      p: ""
    };
  },

  mounted() {
    this.t = this.$route.query.t;
    this.p = this.$route.query.p || "";
    this.requestParams();
  },

  methods: {
    requestParams() {
      this.$axios
        .get(
          "https://home.51point.com/51point-0.0.1-SNAPSHOT/questionnaireanswer/edpInfo",
          { params: { t: this.t, p: this.p } }
        )
        .then(res => {
          console.log(res);
          this.TID = res.data.data.tid || "";
          this.isfinished = res.data.data.isf || 1;
          this.unionId = res.data.data.tid || "";
          this.type = res.data.data.tp || 1;
          this.prId = res.data.data.prid || "";
          this.nowLevel = res.data.data.nowl || "2";
          this.setupData();
        });
    },

    // 设置数据
    setupData() {
      console.log(
        `TID = ${this.unionId}, type = ${this.type}, prId = ${
          this.prId
        }, isfinished = ${this.isfinished}, nowLevel = ${this.nowLevel}`
      );
      // type：1 现金问卷； 2 即付问卷；3 点子问卷；
      // isfinished：1，成功； isfinished：其他，失败/满员
      if (this.isfinished == 1) {
        // 成功完成
        if (this.type == 1) {
          // 现金问卷
          this.title = "奖励金将转入微信零钱";
          this.subtitle = "请在“现金问卷”频道“已完成”中查询";
          this.firstCellTitle = "现金问卷";
          this.firstCellSubtitle = "回答成功可获得奖励金，失败获得10个点子";
          this.isShowFirstCell = true;
          this.isShowSecondCell = false;
          this.btnTxt = "加速提现";
          this.isShowSubNotice = true;
        } else if (this.type == 2) {
          // 即付问卷
          this.title = `获得${this.nowLevel}元奖励金立即提现`;
          this.subtitle = "请在“即付问卷”频道“已完成”中查询";
          this.isShowFirstCell = false;
          this.secondCellTitle = "即付问卷";
          this.secondCellSubtitle = "回答成功可获奖励金即时兑付，失败获10个点";
          this.isShowSecondCell = true;
          this.btnTxt = "查看账单详情";
          this.isShowSubNotice = false;

          // 显示等级
          this.isShowBulb = true;
        } else if (this.type == 4) {
          // cint
          this.title = `获得3元奖励金立即提现`;
          this.subtitle = "请在“肥牛卷”频道“已完成”中查询";
          this.isShowFirstCell = false;
          this.isShowSecondCell = false;
          this.btnTxt = "";
          this.isShowSubNotice = false;
          this.isShowBulb = false;
        } else {
          // 点子问卷
          this.title = "奖励相应的点子数";
          this.subtitle = "请在“我的点子”频道“点子动态”中查询";
          this.firstCellTitle = "点子问卷";
          this.firstCellSubtitle = "回答可获相应的点子数，累积兑换到零钱";
          this.isShowFirstCell = true;
          this.secondCellTitle = "我的点子";
          this.secondCellSubtitle = "查询点子动态及兑换到微信零钱";
          this.isShowSecondCell = true;
          this.btnTxt = "";
          this.isShowSubNotice = false;
        }
      } else {
        // 失败或者满额
        if (this.type == 1) {
          // 现金问卷
          this.title = "未成功完成，奖励您10个点子";
          this.subtitle = "请在“我的点子”频道“点子动态”中查询";
          this.firstCellTitle = "现金问卷";
          this.firstCellSubtitle = "回答成功可获得奖励金，失败获得10个点子";
          this.isShowFirstCell = true;
          this.secondCellTitle = "我的点子";
          this.secondCellSubtitle = "查询点子动态及兑换到微信零钱";
          this.isShowSecondCell = true;
          this.btnTxt = "";
          this.isShowSubNotice = false;
        } else if (this.type == 2) {
          // 即付问卷
          this.title = "未成功完成，奖励您10个点子";
          this.subtitle = "请在“我的点子”频道“点子动态”中查询";
          this.firstCellTitle = "即付问卷";
          this.firstCellSubtitle = "回答成功可获奖励金即时兑付，失败获10个点";
          this.isShowFirstCell = false;
          this.secondCellTitle = "我的点子";
          this.secondCellSubtitle = "查询点子动态及兑换到微信零钱";
          this.isShowSecondCell = true;
          this.btnTxt = "再次参与";
          this.isShowSubNotice = false;

          // 显示等级
          this.isShowBulb = true;
        } else if (this.type == 4) {
          // cint
          this.title = `未成功完成，奖励相应的点子数`;
          this.subtitle = "请在“我的点子”频道“点子动态”中查询";
          this.isShowFirstCell = false;
          this.isShowSecondCell = false;
          this.btnTxt = "";
          this.isShowSubNotice = false;
          this.isShowBulb = false;
        } else {
          // 点子问卷
          this.title = "非常遗憾，您的条件可能与这次的问卷不符";
          this.subtitle = "奖励您10点点子数";
          this.firstCellTitle = "点子问卷";
          this.firstCellSubtitle = "回答可获相应的点子数，累积兑换到零钱";
          this.isShowFirstCell = true;
          this.secondCellTitle = "我的点子";
          this.secondCellSubtitle = "查询点子动态及兑换到微信零钱";
          this.isShowSecondCell = true;
          this.btnTxt = "";
          this.isShowSubNotice = false;
        }
      }
    },

    onTapFirstCell() {
      if (this.type == 1) {
        // 现金问卷
        this.$router.push({ path: "/cash" });
      } else if (this.type == 2) {
        // 即付问卷
        this.$router.push({ path: "/instant" });
      } else {
        // 点子问卷
        this.$router.push({ path: "/point" });
      }
    },

    onTapSecondCell() {
      if (this.type == 1) {
        // 现金问卷
        this.$router.push({ path: "/profile" });
      } else if (this.type == 2) {
        // 即付问卷
        if (this.isfinished == 1) {
          // 成功，跳到即付问卷
          this.$router.push({ path: "/instant" });
        } else {
          // 失败，跳到我的点子
          this.$router.push({ path: "/profile" });
        }
      } else {
        // 点子问卷
        this.$router.push({ path: "/profile" });
      }
    },

    onTapBtn() {
      if (this.type == 1) {
        // 加速提现
        localStorage.setItem("cashPrId", this.prId);
        this.$router.push({ path: "/award" });
      } else if (this.type == 2) {
        if (this.isfinished == 1) {
          // 查看账单，即付问卷详情
          let unionId = getCookie("unionId");
          this.$axios
            .get(
              "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiCompletedDetailForPc",
              { params: { param: unionId, pid: this.prId } }
            )
            .then(res => {
              console.log(res);
              this.dialog = res.data.data;
              this.isShow = true;
            });
        } else {
          // 再次参与
          let params = { param: this.unionId };
          this.$axios
            .get(
              "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiQuestionnaireForPc",
              { params }
            )
            .then(res => {
              window.location.href = res.data.data.link;
            });
        }
      }
    },

    closeDialog() {
      this.isShow = false;
    },

    onTapTixianAgain() {
      let unionId = getCookie("unionId");
      this.$axios
        .get(
          "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/updateSForPc",
          {
            params: { param: unionId, i: this.prId }
          }
        )
        .then(res => {
          this.$axios
            .get(
              "https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiCompletedDetailForPc",
              { params: { param: unionId, pid: this.prId } }
            )
            .then(res => {
              console.log(res);
              this.dialog = res.data.data;
              this.isShow = true;
            });
        });
    }
  }
};
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-content {
  height: 224px;
  width: 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  position: relative;
}

.success {
  background: #e3696a url(../assets/img/success@2x.png) no-repeat center;
  background-size: 375px 224px;
}

.fail {
  background: #67ad73 url(../assets/img/fail@2x.png) no-repeat center;
  background-size: 375px 224px;
}

.cell-content {
  background: #f5f5f5;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-self: stretch;
  padding-top: 20px;
  padding-bottom: 20px;
}

.cell {
  display: flex;
  flex-direction: column;
  margin: 0 20px;
  background: white;
  padding: 20px;
  cursor: pointer;
  width: 30%;
}

.cell .title {
  font-size: 16px;
  color: #333;
}

.cell .subtitle {
  font-size: 12px;
  color: #999;
  margin-top: 20px;
}

.btn-content {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: #f5f5f5;
  padding-bottom: 20px;
}

.btn {
  color: white;
  background: #68ad73;
  font-size: 16px;
  width: 30%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}

.txt-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  background: #f5f5f5;
  padding-bottom: 20px;
}

.txt-space {
  flex-grow: 1;
}

.txt-content p {
  font-size: 14px;
  color: #999;
  line-height: 18px;
  flex-shrink: 0;
}

.txt {
  margin-bottom: 10px;
  color: white;
  font-size: 16px;
}

.txt-title {
  font-size: 18px;
}

.bulbs-card {
  width: 100%;
  background: #f5f5f5;
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
}

.bulbs-inside {
  background: white;
  width: 30%;
  margin: 10px auto;
}
</style>
